import { render, staticRenderFns } from "./SportTypeVariantBadge.vue?vue&type=template&id=3213d295&scoped=true"
import script from "./SportTypeVariantBadge.vue?vue&type=script&lang=ts"
export * from "./SportTypeVariantBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213d295",
  null
  
)

export default component.exports